import {ILogService, IScope} from "angular";
import {Announcement, EAnnouncementCategory, EAnnouncementNotification, EAnnouncementType} from "../../../../data/announcement.data";
import PrivilegeService from "../../../../services/privilege.service";
import RestService from "../../../../services/rest.service";

require('./edit.announcement.modal.scss')

/* @ngInject */
export default class EditAnnouncementModalController {

  types: string[] = Object.keys(EAnnouncementType).filter((item) => {
    return isNaN(Number(item));
  });

  categories: string[] = Object.keys(EAnnouncementCategory).filter((item) => {
    return isNaN(Number(item));
  });

  notifications: string[] = Object.keys(EAnnouncementNotification);

  private startDate: Date;
  private endDate: Date;
  private isLoading: boolean;
  public isLoadingReceivers = false;

  constructor(private $log: ILogService, private $scope: IScope, private $uibModalInstance, private $uibModal, private restService: RestService,
              private announcement: Announcement, public privilegeService: PrivilegeService, private Notification, private $translate) {
    this.startDate = new Date(announcement.startDate);
    this.endDate = new Date(announcement.endDate);
  }

  save() {
    this.isLoading = true;
    this.restService.saveAnnouncement(this.announcement).then(announcement => {
      this.announcement = announcement
      this.isLoading = false;
      this.$uibModalInstance.close()
    }, err => {
      this.$log.error(err);
      this.isLoading = false;
      this.$scope.$applyAsync()
    });
  }

  reload() {
    this.isLoadingReceivers = true;
    this.restService.getAnnouncementAndCalculateReceivers(this.announcement.id, this.announcement.notification).then(announcement => {
      this.announcement.receivers = announcement.receivers;
    }, err => {
      this.$log.error(err);
      
    }).finally(() => {
      this.isLoadingReceivers = false;
      this.$scope.$applyAsync()
    });
  }

  selectNotification(notification: EAnnouncementNotification) {
    this.announcement.notification = notification;
    this.reload();
  }

  close() {
    this.$uibModalInstance.close();
  }

  delete() {
    this.$uibModal.open({
      template: require('../../../modals/misc/confirm.delete.modal/confirm.delete.modal.html'),
      controller: 'ConfirmDeleteModalController',
      controllerAs: 'ctrl',
      size: 'md',
      resolve: {
        okFunction: () => {
          return () => {
            this.isLoading = true
            this.restService.deleteAnnouncementById(this.announcement.id).then((res) => {
              this.isLoading = false
              this.close()
            }, err => {
              this.$log.error(err)
              this.isLoading = false
              this.$scope.$applyAsync()
            })
          };
        },
        additionalText: () => {
          return;
        }
      }
    });
  }

  dateChanged() {
    if (this.startDate > this.endDate) {
      this.endDate = new Date(this.startDate);
    }
    this.announcement.startDate = this.startDate;
    this.announcement.endDate = this.endDate;
  }

  send() {
    this.isLoadingReceivers = true;
    this.restService.saveAnnouncement(this.announcement).then(() => {
      this.restService.sendAnnouncement(this.announcement.id).then((announcement) => {
        this.announcement = announcement;
        this.$translate('ANNOUNCEMENTS.SEND_SUCCESS').then((translation) => {
          this.Notification.success({
            message: translation,
            title: this.announcement.title
          });
        });
      }).finally(() => {
        this.isLoadingReceivers = false;
        this.$scope.$applyAsync()
      });
    });
  }

  sendNotification() {
    this.$uibModal.open({
      template: require('../../../modals/misc/confirm.modal/confirm.modal.html'),
      controller: 'ConfirmModalController',
      controllerAs: 'ctrl',
      size: 'sm',
      resolve: {
        okFunction: () => {
          return () => {
            this.send();
          };
        },
        text: () => {
          return 'ANNOUNCEMENTS.CONFIRM_SENDING';
        },
        info: () => {
          return this.announcement.title;
        }
      }
    });
  }


}